import { useEffect, useState } from "react";
import { navStore, useNavStore } from "./nav-store";
const RAIL_QUERY = "(min-width: 768px) and (max-width: 1279.98px)";
const FULL_QUERY = "(min-width: 1280px)";
const readViewport = () => {
    if (typeof window === "undefined" || !window.matchMedia)
        return "full";
    if (window.matchMedia(FULL_QUERY).matches)
        return "full";
    if (window.matchMedia(RAIL_QUERY).matches)
        return "rail";
    return "drawer";
};
const resolve = (viewport, collapsed) => viewport === "full" ? (collapsed ? "rail" : "full") : viewport;
// Stamp the mode before the first paint. Without this the content column spends
// one frame on the `.layout-main` default width, which flashes on small screens.
if (typeof document !== "undefined") {
    document.body.dataset.navMode = resolve(readViewport(), navStore.getState().collapsed);
}
export const useNavMode = () => {
    const { collapsed } = useNavStore();
    const [viewport, setViewport] = useState(readViewport);
    useEffect(() => {
        const lists = [
            window.matchMedia(FULL_QUERY),
            window.matchMedia(RAIL_QUERY),
        ];
        const sync = () => setViewport(readViewport());
        lists.forEach((mql) => mql.addEventListener("change", sync));
        sync();
        return () => lists.forEach((mql) => mql.removeEventListener("change", sync));
    }, []);
    const mode = resolve(viewport, collapsed);
    // Publish the mode on <body> so the content column can offset itself in pure CSS
    // instead of Layout re-rendering the whole page tree on every toggle.
    // No cleanup on purpose: every page renders its own <Layout>, so this unmounts
    // on each navigation — removing the attribute there would snap the content
    // column to its default width for a frame on every route change.
    useEffect(() => {
        document.body.dataset.navMode = mode;
    }, [mode]);
    // Leaving mobile must never leave an orphaned drawer behind.
    useEffect(() => {
        if (viewport !== "drawer")
            navStore.setDrawerOpen(false);
    }, [viewport]);
    return mode;
};
